module.exports = __webpack_public_path__ + "static/img/pair-xd.325f86b7.svg";